import React, { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import api from "../../apis/EdisonApi";
import Loader from "../common/Loader";
import energyPalette from "../../theme/energyPalette";

const lastValue = (values) =>
	Array.isArray(values) && values.length > 0 ? Number(values[values.length - 1]) || 0 : 0;

const SelfConsumptionStatus = () => {
	const [status, setStatus] = useState(null);

	useEffect(() => {
		const controller = new AbortController();

		api.get("/home/aggregate-energy-data", { signal: controller.signal })
			.then((response) => setStatus(response.data))
			.catch((error) => {
				if (error.name !== "CanceledError") {
					toast.error("API error getting aggregated self-consumption data");
				}
			});

		return () => controller.abort();
	}, []);

	const breakdown = useMemo(() => {
		if (!status) return null;

		const panel = Math.max(0, Math.round(lastValue(status.perc_panel)));
		const battery = Math.max(0, Math.round(lastValue(status.perc_batt)));
		const grid = Math.max(0, 100 - panel - battery);

		return {
			autonomy: Math.max(0, Math.round(lastValue(status.autosuff_avg))),
			panel,
			battery,
			grid,
		};
	}, [status]);

	return (
		<div className="animated flipInY col-lg-4 col-md-4 col-sm-6 col-xs-12">
			<div className="tile-stats self-consumption-card">
				<h3>Self consumption</h3>
				{!breakdown ? (
					<Loader size={20} />
				) : (
					<>
						<div className="self-consumption-card__value">{breakdown.autonomy}%</div>
						<div
							className="self-consumption-bar"
							role="img"
							aria-label={`Energy sources: ${breakdown.panel}% solar, ${breakdown.battery}% battery, ${breakdown.grid}% grid`}
						>
							<span className="self-consumption-bar__panel" style={{ width: `${breakdown.panel}%`, backgroundColor: energyPalette.solar }} />
							<span className="self-consumption-bar__battery" style={{ width: `${breakdown.battery}%`, backgroundColor: energyPalette.battery }} />
							<span className="self-consumption-bar__grid" style={{ width: `${breakdown.grid}%`, backgroundColor: energyPalette.grid }} />
						</div>
					</>
				)}
				<div className="icon tile-icon--efficiency"><FontAwesomeIcon icon={faLeaf} /></div>
			</div>
		</div>
	);
};

export default SelfConsumptionStatus;
